/**
 * About Page Code
 *
 * Each unique page (or template) has its own page script.  These
 * scripts are loaded into the template, along with the main.js
 * script, and any vendor scripts needed for the site.  The
 * individual page scripts add a 'page' object into the main
 * Otto namespace, and the main.js file then init()'s this
 * page object to execute whatever page-specific code needs
 * to be run.
 */

/* global jQuery */

var Otto = Otto || {};
Otto.page = (function(my, $) {
    // Create object for storing our methods for public consumption
    // (this sets up our external API for this module)
    var exports = {};


    function wireEvents() {
        var $item = null;

        // Hook up in-page links (for scrolling between sections)
        var links = $('a');
        for (var i = 0; i < links.length; i++) {
            var link = links[i];
            if (link.href.indexOf('#') > -1) {
                $(link).on('click', function(evt) {
                    evt.preventDefault();
                    var target = evt.currentTarget.href.split('#')[1];
                    $(window).scrollTo('#' + target, 750);
                });
            }
        }

    }


    exports.init = function() {
        // Initialize timeline scrolling
        $('.timeline').niceScroll(
                            {railpadding:{top:1,right:2,left:2,bottom:1},
                             cursorborder:"0",
                             cursorcolor:"#222222",
                             touchbehavior:true,
                             hidecursordelay:1000});

        wireEvents();
    };

    return exports;

})(Otto, jQuery);